module.exports = __webpack_public_path__ + "static/media/trust-shipment-w.581d10c1.svg";